import React from 'react'
import propTypes from 'prop-types'
import {
  Button,
  ModalCardBody,
  ModalCardHeader,
  ModalCardTitle,
  ModalCard,
  ModalBackground,
  Modal,
  Control,
  Field as BulmaField,
  Subtitle,
  Media,
  MediaLeft,
  MediaContent,
} from 'src/ui/mui-ui-kit'
import { usePoseWithBulma } from 'src/ui/hooks'
import { FadeInDiv, AnimatedCard } from 'src/ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function AddAccountModal({ isActive, onCancel, values }) {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );

  if (!values) {
    return null;
  }

  return (
    <Modal isActive={isModalVisible} className="add-account-invitation">
      <ModalBackground
        tag={FadeInDiv}
        pose={currentPose}
        onPoseComplete={onPoseComplete}
      />
      <ModalCard tag={AnimatedCard} pose={currentPose}>
        <ModalCardHeader>
          <ModalCardTitle
            tag="h5"
            hasTextAlign="centered"
            className="has-text-weight-semibold"
          >
            Confirm Invite
          </ModalCardTitle>
        </ModalCardHeader>
        <ModalCardBody>
          <Media>
            <MediaLeft>
              <span className="icon has-icon-gradient-bright is-large">
                <FontAwesomeIcon icon={['fas', 'user-circle']} size="3x" />
              </span>
            </MediaLeft>
            <MediaContent>
              <Subtitle hasTextColor="primary" isSize="5" tag="h6" isMarginless>
                {values.firstName} {values.lastName}
              </Subtitle>
              <Subtitle hasTextColor="info" isSize="6" tag="p">
                {values.emailAddress}
              </Subtitle>
            </MediaContent>
          </Media>
          <BulmaField isGrouped="centered">
            <Control>
              <Button hasTextColor="info" onClick={onCancel}>
                Cancel
              </Button>
            </Control>
            <Control>
              <Button isColor="gradient-bright" type="submit">
                Confirm Invite
              </Button>
            </Control>
          </BulmaField>
        </ModalCardBody>
      </ModalCard>
    </Modal>
  );
}

AddAccountModal.propTypes = {
  isActive: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
  values: propTypes.object.isRequired,
};
